import { getDisplayText } from './utils';

interface MultiSelectValueProps {
  value: string[];
  showOptions: boolean;
  placeholder: string;

  endIcon?: React.ReactNode;
  selectedCount?: number;
}

const MultiSelectValue = ({
  value,
  showOptions,
  placeholder,
  selectedCount,
  endIcon,
}: MultiSelectValueProps) => {
  const placeholderClass = showOptions ? 'text-tpg_light' : '';

  if (showOptions || value.length === 0) {
    return <span className={placeholderClass}>{placeholder}</span>;
  }

  if (value.length === 1) {
    return <span className="truncate max-w-[200px] min-w-0">{value[0]}</span>;
  }

  return (
    <>
      <span className="truncate max-w-[200px] min-w-0">
        {getDisplayText(value)}
      </span>
      {Boolean(selectedCount) && (
        <span className="px-1 flex-shrink-0 normal-case flex items-center justify-center gap-1 text-bright_product">
          {selectedCount}
          {endIcon}
        </span>
      )}
    </>
  );
};

export default MultiSelectValue;
